import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tdms-viz-dashboard-doc-tab',
    templateUrl: './viz-dashboard-doc-tab.component.html',
    styleUrls: ['../doc-tab.component.scss'],
    standalone: false
})
export class VizDashboardDocTabComponent implements OnInit {

  selectedTabs:number[] = [];

  constructor() { }

  ngOnInit() {
  }
  
  isOpen(tab:number): boolean{
    if (this.selectedTabs.includes(tab)){ return true; }
    return false;
  }

  toggleTab(tab:number){
    if (this.selectedTabs.includes(tab)) {
      this.selectedTabs = this.selectedTabs.filter(t => t != tab);
    } else {
      this.selectedTabs.push(tab);
    }
  }

}
